import * as z from "zod/v4";

export const getGorgiasConnectionStatus = {
  name: "getGorgiasConnectionStatus" as const,
  input: z.object({}),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    hasTicketScope: z.boolean(),
  }),
};
